import { useCallback, useMemo } from 'react'

import { Select, Tag } from 'antd'
import { isArray, isFunction } from 'lodash'

import { isNonEmptyArray, isObject } from '../../../utils'

const EntitiesSelector = ({
  className = '', disabled, empty = false, entityOptions, highlightValues = [], loading, multiple = 'multiple', notFoundContent, showSearch = false, style = {}, values = [], placeholder,
  onChange, dropdownRender
}) => {
  const highlightMap = useMemo(() => {
    const map = {}

    if (isNonEmptyArray(highlightValues)) {
      highlightValues.forEach(value => {
        map[value] = true
      })
    }

    return map
  }, [highlightValues])

  const sortedOptions = useMemo(() => {
    let sortedOptions = entityOptions

    if (Object.keys(highlightMap).length > 0) {
      sortedOptions = [...sortedOptions].sort((a, b) => {
        const aWeight = highlightMap[a.value] ? 1 : 0
        const bWeight = highlightMap[b.value] ? 1 : 0

        return bWeight - aWeight
      })
    }

    return sortedOptions
  }, [highlightMap, entityOptions])

  const handleFilter = useCallback((input, option) => {
    const { label, title } = option.props

    return (
      (label && label.toLowerCase().includes(input.toLowerCase())) ||
      (title && title.toLowerCase().includes(input.toLowerCase()))
    )
  }, [])

  const handleOptionChange = useCallback((value, option) => {
    let entities = null

    if (isArray(option)) {
      entities = option.map(o => o.props.entity)
    } else if (isObject(option?.props)) {
      entities = option.props.entity
    }

    onChange(value, option, entities)
  }, [onChange])

  const Placeholder = useMemo(() => !isNonEmptyArray(values) && placeholder && (
    <Tag className='fs-15 h-20'>
      <span>{placeholder}</span>
    </Tag>
  ), [values, placeholder])

  return (
    <Select
      placeholder={Placeholder}
      disabled={disabled}
      loading={loading}
      mode={multiple}
      allowClear
      showSearch={showSearch}
      value={values}
      optionFilterProp='label'
      notFoundContent={notFoundContent}
      onChange={handleOptionChange}
      filterOption={handleFilter}
      style={{ ...style }}
      dropdownRender={isFunction(dropdownRender) ? dropdownRender : undefined}
    >
      {empty && (
        <Select.Option
          title='/'
          value={null}
          label='/'
          entity={null}
        >
          /
        </Select.Option>
      )}
      {sortedOptions.map(entityOption => (
        <Select.Option
          key={'entity_' + entityOption.value}
          className={className + (highlightMap[entityOption.value] ? ' color-neutral' : '')}
          title={entityOption.tooltip}
          value={entityOption.value}
          label={entityOption.label}
          entity={entityOption.entity}
        >
          {entityOption.label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default EntitiesSelector
